import { navigate } from 'gatsby';
import { getWindowLocation } from 'lib/util';

export const goToLogin = (redirectPath?: string) => {
  const location = getWindowLocation();
  if (!redirectPath && location.pathname === '/') return navigate('/login');

  navigate(`/login?redirect=${encodeURIComponent(redirectPath || location.pathname)}`);
};
